import React from 'react';
import './Dashboard.css';

function Placeholder({ title }) {
  return (
    <div className="section">
      <h2>{title}</h2>
      <p className="muted">This page is a placeholder. Implement the feature as needed.</p>
    </div>
  );
}

export default Placeholder;
